"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The PasswordResetResult model module.
 * @module model/PasswordResetResult
 * @version 1.1.3-alpha.1
 */
class PasswordResetResult {
  /**
   * Constructs a new <code>PasswordResetResult</code>.
   * @alias module:model/PasswordResetResult
   */
  constructor() {
    PasswordResetResult.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>PasswordResetResult</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PasswordResetResult} obj Optional instance to populate.
   * @return {module:model/PasswordResetResult} The populated <code>PasswordResetResult</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PasswordResetResult();
      if (data.hasOwnProperty('success')) {
        obj['success'] = _ApiClient.default.convertToType(data['success'], 'Boolean');
      }
      if (data.hasOwnProperty('invalid_token')) {
        obj['invalid_token'] = _ApiClient.default.convertToType(data['invalid_token'], 'Boolean');
      }
      if (data.hasOwnProperty('expired')) {
        obj['expired'] = _ApiClient.default.convertToType(data['expired'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>PasswordResetResult</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PasswordResetResult</code>.
   */
  static validateJSON(data) {
    return true;
  }
}

/**
 * @member {Boolean} success
 */
PasswordResetResult.prototype['success'] = undefined;

/**
 * @member {Boolean} invalid_token
 */
PasswordResetResult.prototype['invalid_token'] = undefined;

/**
 * @member {Boolean} expired
 */
PasswordResetResult.prototype['expired'] = undefined;
var _default = exports.default = PasswordResetResult;